import {configureStore} from '@reduxjs/toolkit'
import appReducer from './app.slice'
import jsonScreenReducer from '../Components/JsonScreen/jsonScreen.slice'
import dropdownReducer from '../Components/JsonScreen/dropdown.slice'
import popupReducer from '../Components/JsonScreen/popup.slice'
import screenDesignerReducer
    from "../Components/ApplicationBuilder/ApplicationDesigner/Designers/ScreenDesigner/ScreenDesigner.slice";
import enqueryListReducer
    from "../Components/JsonScreen/Screen/ScreenComponents/ListScreenComponent/List/enqueryList.slice"
import contextMenuSlice from "../Components/JsonScreen/Screen/ScreenComponents/ContextMenu/contextMenu.slice";
import applicationBuilderSlice from "../Components/ApplicationBuilder/reducers/applicationBuilder.slice";
import
    uploadAvatarSlice
    from "../Components/JsonScreen/Screen/ScreenComponents/UploadAvatarPopupComponent/uploadAvatar.slice";

export const store = configureStore({
    reducer: {
        app: appReducer,
        jsonScreen: jsonScreenReducer,
        screenDesigner: screenDesignerReducer,
        dropdown: dropdownReducer,
        popup: popupReducer,
        enqueryList: enqueryListReducer,
        contextMenu: contextMenuSlice,
        applicationBuilder: applicationBuilderSlice,
        uploadAvatar: uploadAvatarSlice,
    }
})